import React from "react";

const Loader = () => <div className="suspense-loader">Loading...</div>;

export default Loader;
